<template>
  <div>
    <selector
      draggable-group="music-questions"
      item-name-plural="music questions"
      item-name="music question"
      v-model="musicQuestions"
      :can-add="true"
      :is-fixed="isFixed"
      :is-editable="isEditable"
      :search-text="selectorMatrixChoiceSearchText"
      :show-category-filter="false"
      @onItemEdit="handleEditItem"
      @onCreate="handleCreate"
      @onLoadMore="handleLoadMore"
      @onResetFilters="handleResetFilters"
      @onChangeSearchText="handleSearchText"
    ></selector>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import { mapState } from 'vuex';

import * as surveyBuilderTypes from '@/store/modules/surveybuilder/mutation-types';

import Selector from './Selector';

const DEBOUNCE_DELAY = 600;

export default {
  name: 'MusicQuestionSelector',
  components: {
    Selector,
  },
  props: {
    isFixed: {
      type: Boolean,
      default: false,
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState('surveybuilder', [
      'matrixChoiceList',
      'matrixChoicesLoading',
      'matrixChoicesPage',
      'selectorMatrixChoiceSearchText',
    ]),
    ...mapState('user', ['me']),

    musicQuestions() {
      return this.matrixChoiceList.map(matrixChoice => ({ ...matrixChoice, isEditable: true }));
    },
  },
  methods: {
    handleEditItem(item) {
      this.$store.commit(`surveybuilder/${surveyBuilderTypes.SET_MATRIX_CHOICE_DIALOG_FORM}`, item);
      this.$store.commit(
        `surveybuilder/${surveyBuilderTypes.SET_MATRIX_CHOICE_DIALOG_VISIBILITY}`,
        true,
      );
    },

    handleCreate() {
      this.$store.commit(
        `surveybuilder/${surveyBuilderTypes.SET_MATRIX_CHOICE_DIALOG_VISIBILITY}`,
        true,
      );
    },

    handleSearchText(text) {
      this.$store.commit(
        `surveybuilder/${surveyBuilderTypes.SET_SELECTOR_MATRIX_CHOICE_TEXT}`,
        text,
      );
      this.handleDebounceGet();
    },

    handleResetFilters() {
      this.$store.commit(
        `surveybuilder/${surveyBuilderTypes.RESET_SELECTOR_MATRIX_CHOICE_FILTERS}`,
      );
      this.$store.dispatch('surveybuilder/getMatrixChoices');
    },

    // eslint-disable-next-line
    handleDebounceGet: debounce(function() {
      this.$store.dispatch('surveybuilder/getMatrixChoices');
    }, DEBOUNCE_DELAY),

    handleLoadMore() {
      if (this.matrixChoiceList.length && !this.matrixChoicesLoading) {
        this.$store.dispatch('surveybuilder/getMoreMatrixChoices');
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// MusicQuestionSelector.vue?14b29d2e